import React, { useEffect } from 'react';
import UpperLeftGreenpillSection from './UpperLeftGreenpillSection';
import noPillSelected from '../../assets/greenpill/noPillSelected.png';
import { useHome } from '../../contexts/HomeContext';
import { getAchievmentImpactPoints } from '../../apis/geenpills/apis';
import ProgressBar from '../../ui/ProgressBar';

const UpperGreenpillSection = () => {
    const { state: homeState } = useHome();
    useEffect(function () {
        const fetchData = async () => {
            try {
                const response = await getAchievmentImpactPoints();
                console.log(response, 'aaya kya');
            } catch (error) {
                return null;
            }
        };

        fetchData();
    }, []);

    return (
        <div className="">
            <div className="flex  flex-col-reverse lg:flex-row   w-full ">
                <div className=" w-full lg:w-[70%] rounded-t-3xl lg:rounded-none  bg-[#272727] md:bg-inherit p-4  md:p-0  gap-6">
                    <UpperLeftGreenpillSection />
                </div>

                <div className=" w-full lg:w-[30%] relative  bg-mint-mobile-gradient  rounded-t-3xl lg:rounded-t-none  md:bg-none">
                    <div className="w-[30%] lg:w-full  md:h-[35rem]  flex   justify-center">
                        <img
                            className="h-[16.56rem]  lg:h-full object-cover"
                            src={homeState?.selectedPill ? homeState?.selectedPill?.imageURI : noPillSelected}
                            alt="Red NFT"
                        />
                    </div>
                    <div className="w-[80%] absolute bottom-3 right-[50%] translate-x-[50%] ">
                        <div className="flex items-center justify-between">
                            <p className="font-medium text-foundryYellowL">55%</p>
                            <p className="font-medium text-foundryYellowL">2K/3.6K IP</p>
                        </div>
                        <ProgressBar color={'bg-[#FBCF4E]'} width={(1500 / 3600) * 100 + '%'} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpperGreenpillSection;
